import $http from '@Config/axios';
import { DefaultPresenter } from './default-presenter';

const prefix = 'casa_repouso';
const entity = 'Casa de repouso';

export const CasaRepousoPresenter = {
	...DefaultPresenter({ prefix, entity }),
	orcamentos: id => $http.get(`${prefix}/${id}/orcamentos`)
};
